import { render } from "./VimeoEmbed.vue?vue&type=template&id=e70a21e0&scoped=true&ts=true"
import script from "./VimeoEmbed.vue?vue&type=script&lang=ts"
export * from "./VimeoEmbed.vue?vue&type=script&lang=ts"

import "./VimeoEmbed.vue?vue&type=style&index=0&id=e70a21e0&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70a21e0"]])

export default __exports__